var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule Center"},[_c('div',{staticClass:"ruleBox"},[_c('img',{attrs:{"src":require("../assets/rule.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"src":require("../assets/btn/close.png"),"alt":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc6bca4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rule.vue
// module id = null
// module chunks = 